import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import FilterIcon from '../../../../../../assets/images/icons/common_filter_icon.svg';

import './CommonMobileSortMenu.less';

export default function CommonMobileSortMenu({
  onToggleMobileFilters,
  filtersCount,
  redesign = false,
}) {
  const buttonTitle = 'Filter & Sort';
  const filterTitle = filtersCount > 0 ? `${buttonTitle} (${filtersCount})` : buttonTitle;

  return (
    <div
      className={cx('common-filter__mobile-button', { 'button-active': filtersCount, redesign })}
      onClick={onToggleMobileFilters}
    >
      <img className="common-filter__icon" src={FilterIcon} alt="Filter Icon" />
      <span className="common-filter__text">{filterTitle}</span>
    </div>
  );
}

CommonMobileSortMenu.propTypes = {
  onToggleMobileFilters: PropTypes.func,
  filtersCount: PropTypes.number,
  redesign: PropTypes.bool,
};
